<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="6" class="py-2">
                <span><b>Reported Cases</b></span>
              </b-col>
            </b-row>
            <b-row class="text-left" align-v="center">
              <b-col cols="12" md="2" class="pt-3">
                <b-dropdown
                  variant="outline-primary"
                  size="md"
                  id="dropdown-1"
                  :text="tableType.name"
                >
                  <b-dropdown-item
                    v-for="(item, i) in tableTypes"
                    :key="i"
                    @click="getData(item)"
                    >{{ item.name }}</b-dropdown-item
                  >
                </b-dropdown>
              </b-col>
              <b-col cols="12" md="2">
                <span style="font-size: 12px">Please Select From Date:</span
                ><br />
                <b-form-input
                  class="pt-1"
                  v-model="from"
                  type="date"
                  id="date"
                ></b-form-input>
              </b-col>

              <b-col cols="12" md="2">
                <span style="font-size: 12px">Please Select To Date:</span
                ><br />
                <b-form-input
                  class=""
                  v-model="to"
                  type="date"
                  id="date"
                ></b-form-input>
              </b-col>
              <b-col cols="12" md="2" class="pt-3">
                <b-dropdown
                  variant="outline-primary"
                  size="sm"
                  id="dropdown-1"
                  :text="chartName"
                >
                  <b-dropdown-item
                    v-for="(item, i) in chartTypes"
                    :key="i"
                    @click="updateChart(item)"
                    >{{ item.name }}</b-dropdown-item
                  >
                </b-dropdown>
              </b-col>
              <b-col cols="12" md="4" class="pt-3">
                <b-form @submit.prevent="getSearch">
                  <b-row>
                    <b-col cols="8">
                      <b-form-input
                        list="searchData"
                        v-model="searchKey"
                        placeholder="Search"
                        size="md"
                      ></b-form-input>
                      <!-- <datalist id="searchData">
                        <option v-for="(item,i) in searchData" :key="i">{{item.keyword}}</option>
                      </datalist> -->
                    </b-col>
                    <b-col cols="2" class="pt-1">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        @click="getSearch"
                        >Search</b-button
                      >
                    </b-col>
                    <b-col cols="1" class="pt-1">
                      <b-button
                        variant="outline-primary"
                        class="px-2"
                        size="sm"
                        @click="getData(tableTypes[0])"
                        >All</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="incidents"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            @row-clicked="rowClicked"
          >
            <template slot="caseid" slot-scope="data">
              <div class="text-center">
                <span v-if="data.item.caseidentifier">{{
                  data.item.caseidentifier
                }}</span>
                <span v-else>{{ data.item.caseid }}</span>
              </div>
            </template>
            <template slot="createddate" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.createddate">{{
                  formatDate(data.item.createddate)
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
            <template slot="isanonymous" slot-scope="data">
              <!-- <span v-if="data.item.isanonymous">{{data.item.isanonymous}}</span>
              <span v-else>-</span>-->
              <div class="text-center">
                <span v-if="data.item.isanonymous">Yes</span>
                <span v-else>No</span>
              </div>
            </template>
            <template slot="locationname" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.locationname">{{
                  data.item.locationname
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
            <template slot="addedby" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.addedby.name">{{
                  data.item.addedby.name
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
            <template slot="reports" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.reports">{{
                  data.item.reports.length
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalIncidents"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
            />
          </nav>
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data: () => {
    return {
      from: null,
      to: null,
      idset: [],
      tableType: null,
      chartName: "Filter",
      chartType: null,
      chartTypes: [
       { name: "Last 90 Days", value: 90 },
        { name: "Last 60 Days", value: 60 },
        { name: "Last 30 Days", value: 30 },
        { name: "Last 15 Days", value: 15 }
      ],
      tableTypes: [
        { name: "Not Marked", route: "/incident/falsealarm/getlist" },
        { name: "Marked as Spam", route: "/incident/falseincidentlist" },
      ],
      incidents: [],
      fields: [
        { key: "caseid", label: "Case ID", sortable: true },
        { key: "createddate", label: "Posted On", sortable: true },
        { key: "locationname", label: "Location", sortable: true },
        { key: "addedby", label: "Posted By", sortable: true },
        { key: "reports", label: "Reported By", sortable: true },
      ],
      currentPage: 1,
      perPage: 25,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
      totalIncidents: 0,
      searchKey: null,
      searchData: [],
    };
  },
  beforeMount() {
    this.tableType = this.tableTypes[0];
    this.getData(this.tableType);
  },
  methods: {
    nextPage(ev) {
      this.currentPage = ev;
      this.getData(this.tableType);
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    getData(item) {
      this.tableType = item;
      this.appLoading = true;
      this.chartName = "Filter";
      this.chartType = null;
      axios({
        url: item.route,
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        // params: {
        //   count: this.perPage,
        //   page: this.currentPage,
        // },
      })
        .then((response) => {
          this.incidents = response.data.data.reverse();
          for (var i = 0; i < this.incidents.length; i++) {
            this.idset[i] = this.incidents[i]._id;
          }

          this.totalIncidents = response.data.count;
          this.appLoading = false;
        })
        .catch((e) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    // getlastsearches() {
    //   this.appLoading = true;
    //   axios({
    //     url: "/incident/lastsearches",
    //     method: "GET",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //     params: {
    //       count: this.perPage,
    //       page: this.currentPage,
    //     },
    //   })
    //     .then((response) => {
    //       this.searchData = response.data.data;
    //       this.totalIncidents = response.data.totalcount;
    //       this.appLoading = false;
    //     })
    //     .catch((e) => {
    //       this.appLoading = false;
    //       this.ServerError = true;
    //     } );
    // },
    updateChart(item) {
      this.chartName = item.name;
      this.chartType = item.value;
      this.getSearch();
    },
    getSearch() {
      this.appLoading = true;
      // if (this.searchKey || (this.from && this.to)) {
      axios({
        method: "GET",
        url: "/search/reportedcase",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          // count: this.perPage,
          // page: this.currentPage,
          filter: this.chartType,
          keyword: this.searchKey,
          from: this.from,
          to: this.to,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.incidents = response.data.data;
          this.totalIncidents = response.data.totalcount;
        })
        .catch((err) => {
          this.ServerError = true;
        });
      // } else this.getData();
    },
    rowClicked(item) {
      this.$router.push("/FalseAlarms/" + item._id + "/" + this.idset);
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
